import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '../../../common/headers/ModalHeader';

const PickDiffPlanModal = props => {
    const {
        modalHeaderProps,
        modal: {
            modalData: {
                futureCoverageStartDate,
                cb
            }
        },
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => hideModal();
    const onContinue = () => {
        cb();
        hideModal();
    };

    return (
        <Fragment>
            <ModalHeader {...modalHeaderProps } />
            <div className="grid-container">
                <div className="gi-modal__body">
                    <p>
                        <FormattedMessage id="modals.pick_diff_plan" values={{ futureCoverageStartDate }}/>
                    </p>
                </div>
            </div>
            <div className="gi-modal__controls">
                <button onClick={handleCloseModal}
                    className="usa-button gi-button gi-button__outline">
                    <FormattedMessage id="button.cancel"/>
                </button>
                <button onClick={onContinue}
                    className="usa-button gi-button gi-button__primary">
                    <FormattedMessage id="button.continue"/>
                </button>
            </div>
        </Fragment>
    );
};

export default PickDiffPlanModal;
